<template>
  <div class="panel-simple">
    <div class="header global-thead-dark title">
      {{ title }}
    </div>
    <div class="panel-row-without-selector pb-4 mb-5">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentLayout',
  props: {
    title: { type: String, default: '' },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
  padding: 15px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
}
</style>
